import { connect } from 'react-redux';
import { disablePercentageBasedGuidelines, enablePercentageBasedGuidelines, setColorMode, setCurrentLang, setUnit, } from '../../actionCreators';
import PanelFormatSettings from '../../components/handoff/PanelFormatSettings';
import { getCurrentLanguage } from '../../selectors/code';
import { arePercentageBasedGuidelinesEnabled, getColorMode, getUnit, } from '../../selectors/handoff';
function mapStateToProps(state) {
    return {
        unit: getUnit(state),
        currentLang: getCurrentLanguage(state),
        arePercentageGuidesEnabled: arePercentageBasedGuidelinesEnabled(state),
        colorMode: getColorMode(state),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        changeMeasurementUnit: function (unit) {
            dispatch(setUnit(unit));
        },
        changeColorMode: function (colorMode) {
            dispatch(setColorMode(colorMode));
        },
        setCurrentLang: function (lang) {
            dispatch(setCurrentLang(lang));
        },
        enablePercentageGuides: function () {
            dispatch(enablePercentageBasedGuidelines());
        },
        disablePercentageGuides: function () {
            dispatch(disablePercentageBasedGuidelines());
        },
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(PanelFormatSettings);
